import React, { useState } from "react";
import { toast } from "react-toastify";
import { Button, StaticDropdown } from "src/Components";
import UsersMultiSelectDropdown from "src/Components/Dropdown/Users/UsersMultiSelectDropdown";
import { Packet } from "src/Interfaces/commonDtos";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import {
  setCloseDayBulkOff,
  setCloseDayBulkON,
  setMiddleDayBulkOff,
  setMiddleDayBulkON,
} from "src/Requests/collateral";
import { packetErrorHandler } from "src/Utils/requestUtils";

enum Actions {
  MiddleDayBulkOn = 1,
  MiddleDayBulkOff,
  CloseDayBulkOn,
  CloseDayBulkOff,
}

interface IProps {
  refreshTable: () => void;
  setAccountIds: (accountIds: number[]) => void;
  accountIds: number[];
  selectedAccountIds: number[];
  setSelectedAccountIds: (selectedAccountIds: number[]) => void;
}

const BulkActions = ({
  refreshTable,
  setAccountIds,
  accountIds,
  selectedAccountIds,
  setSelectedAccountIds,
}: IProps) => {
  const [action, setAction] = useState(0);
  const [loading, setLoading] = useState(false);

  const actionsDropdownChildren: DropdownItem[] = [
    {
      id: Actions.MiddleDayBulkOn,
      name: "روشن کردن تطبیق میان روز",
    },
    {
      id: Actions.MiddleDayBulkOff,
      name: "خاموش کردن تطبیق میان روز",
    },
    {
      id: Actions.CloseDayBulkOn,
      name: "روشن کردن تطبیق پایان روز",
    },
    {
      id: Actions.CloseDayBulkOff,
      name: "خاموش کردن تطبیق پایان روز",
    },
  ];

  const getFunction = (): Promise<Packet<boolean>> => {
    switch (action) {
      case Actions.MiddleDayBulkOn:
        return setMiddleDayBulkON(selectedAccountIds);

      case Actions.MiddleDayBulkOff:
        return setMiddleDayBulkOff(selectedAccountIds);

      case Actions.CloseDayBulkOff:
        return setCloseDayBulkOff(selectedAccountIds);

      case Actions.CloseDayBulkOn:
        return setCloseDayBulkON(selectedAccountIds);
      default:
        return setCloseDayBulkON(selectedAccountIds);
    }
  };

  const submitHandler = () => {
    setLoading(true);
    getFunction()
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
          refreshTable();
          setSelectedAccountIds([])
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex flex-row justify-start items-end gap-5 mx-auto">
      <div className="w-64">
        <UsersMultiSelectDropdown
          label="اکانت"
          name=""
          onChange={(_, v) => setAccountIds(v)}
          extraLabel
          value={accountIds}
        />
      </div>
      <div className="w-64">
        <StaticDropdown
          dropdown={{
            name: "",
            placeholder: "عملیات گروهی",
            extraLabel: true,
          }}
          onChange={(_, v) => setAction(v)}
          options={actionsDropdownChildren}
          value={action}
        />
      </div>
      <div className="w-min">
        <Button
          text="ثبت"
          variant="contained"
          onClick={submitHandler}
          disabled={
            loading ||
            !selectedAccountIds ||
            !selectedAccountIds.length ||
            !action
          }
        />
      </div>
    </div>
  );
};

export default BulkActions;
